import React from 'react';
import s from '../../styles/corporate/Corporate.module.css';

/** public/corporate 아래의 사진 주소 */
export const asset = (file) => `${process.env.PUBLIC_URL}/corporate/${file}`;

/**
 * 사진 한 칸. 아직 파일이 없는 자리는 설명이 적힌 자리표시로 둔다.
 * @param file public/corporate 안의 파일명
 */
const Shot = ({ file, alt = '', placeholder, eager = false }) => {
  if (!file) {
    return <div className={s.shot}>{placeholder}</div>;
  }

  return (
    <img
      className={s.shotImg}
      src={asset(file)}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      aria-hidden={alt ? undefined : 'true'}
    />
  );
};

export default Shot;
